import React, { Component } from "react";
import ItemDetails from './ItemDetails';

class ItemList extends Component {
  render() {
    return ItemList = this.props.items.map((item, key) => {
      return (
        <ItemDetails
          itemName={item.name}
          keyID={key}
          userAssigned={item.userAssigned}
          total={item.total}
          loggedInUser={this.props.loggedInUser}
          tableID={this.props.tableID}
          paid={item.paid}
        />
      )
    });
  }
}

export default ItemList;


// WEBPACK FOOTER //
// ./src/Components/ItemList.js